import { onBeforeUnmount } from 'vue';
import { useDefaultDataLayer } from '../useDataLayer';

const THROTTLE_DELAY = 500;

const sanitizePromotionItem = (item = {}) => {
  const fallbacks = {
    promotion_id: '',
    promotion_name: '',
  };

  return Object.fromEntries(
    Object.entries({ ...fallbacks, ...item }).map(([key, value]) => [key, value ?? ''])
  );
};

export function usePromotionTracking({ componentName = '' } = {}) {
  const { registerPromotionEvent } = useDefaultDataLayer();

  let pendingItems = [];
  let flushTimeoutId = null;

  const flush = () => {
    if (!pendingItems.length) {
      return;
    }

    const items = pendingItems;
    pendingItems = [];
    flushTimeoutId = null;

    registerPromotionEvent({
      event: 'view_promotion',
      component: componentName,
      ecommerce: {
        items,
      },
    });
  };

  const scheduleFlush = () => {
    if (flushTimeoutId) return;

    flushTimeoutId = setTimeout(flush, THROTTLE_DELAY);
  };

  const trackPromotionView = (promotionItem = {}) => {
    pendingItems.push(sanitizePromotionItem(promotionItem));
    scheduleFlush();
  };

  const trackPromotionSelect = (promotionItem = {}) => {
    registerPromotionEvent({
      event: 'select_promotion',
      component: componentName,
      ecommerce: {
        items: [sanitizePromotionItem(promotionItem)],
      },
    });
  };

  onBeforeUnmount(() => {
    if (flushTimeoutId) {
      clearTimeout(flushTimeoutId);
      flushTimeoutId = null;
    }

    flush();
  });

  return {
    trackPromotionView,
    trackPromotionSelect,
  };
}
